module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/assets/templates/workshop-2f2fe16a2e9ca8f855b3fb92845d4a99.png";